import React from 'react';
import withScriptjs from 'react-google-maps/lib/withScriptjs';
import withGoogleMap from 'react-google-maps/lib/withGoogleMap';
var {
  compose,
  withProps
} = require('recompose');
export var mapEnvironment = compose(withProps({
  googleMapURL: "https://maps.googleapis.com/maps/api/js?key=".concat(GOOGLE_MAPS_API_KEY, "&v=3.exp&libraries=geometry,drawing,places"),
  loadingElement: /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  }),
  containerElement: /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  }),
  mapElement: /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%"
    }
  })
}), withScriptjs, withGoogleMap);